module.exports = __webpack_public_path__ + "static/media/pending-status.6efd6820.svg";